//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import uniRate from "@/components/uni-rate/uni-rate.vue"
export default {
  data() {
    return {
      commentData: [],
      loading: false,
      orderCode: '',
      orderType: '',
      isDetail: '',
      isCryptonym: 0
    }
  },
  components: {
    uniRate
  },
  onLoad(e) {
    this.orderCode = e.orderCode
    this.orderType = e.orderType
    this.isDetail = e.isDetail || '0'
  },
  onReady() {
    this.init()
  },
  methods: {
    textInput(e, index) {
      this.commentData[index].content = e.detail.value
    },
    changeCheck(e) {
      if (e.detail.value.indexOf('check') > -1) {
        this.isCryptonym = 1
      } else {
        this.isCryptonym = 0
      }
    },
    changeRate(e, index) {
      this.commentData[index].starLevel = e.value
    },
    init() {
      this.$ajax({
        method: 'post',
        url: this.isDetail == 0 ? '/weChat/comment/before/detail' : '/weChat/comment/detail',
        data: {
          currentPage: '',
          pageSize: '',
          orderCode: this.orderCode
        },
      }).then(res => {
        this.commentData = res.data
      })
    },
    submit() {
      this.commentData.forEach(e => {
        e.orderType = this.orderType
        e.isCryptonym = this.isCryptonym
        e.productShowName = e.bodyName + e.productName + e.skuName
        e.commentator = this.$store.state.userInfo.nickname || '' // 需要处理
        e.commentatorId = this.$store.state.userInfo.memberId || '560106391172284416' // 需要处理
      })
      let obj = JSON.stringify(this.commentData)
      this.loading = true
      this.$ajax({
        method: 'post',
        url: '/weChat/comment/add',
        data: {
          lists: obj
        }
      }).then(res => {
        uni.showToast({
          title: '评价成功',
          icon: 'none'
        })
        this.loading = false
        uni.redirectTo({
          url: '/pages/personalCenter/order/detail?orderCode=' + this.orderCode
        })
      }).catch(() => {
        this.loading = false
      })
    },
  }
}
